import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { ShopContext } from '../context/ShopContext';
import { useParams, useNavigate } from "react-router-dom";
import CategoryTabs from "../components/categorytabs/CategoryTabs";
import CakeProductPage from "../components/productdisplay/CakeProductPage";
import GenericProductPage from "../components/productdisplay/GenericProductPage";
import DescriptionBox from "../components/descriptionbox/DescriptionBox";
import RelatedProducts from "../components/relatedproducts/RelatedProducts";
import ScrollToTop from "../components/util/ScrollToTop";
import ProductReviews from "../components/productdisplay/ProductReviews";
import useProductReviews from "../hooks/useProductReviews";
import Seo, { SITE_URL } from "../components/seo/Seo";

const CATEGORY_LABELS = {
    cake: "Cake",
    tailoring: "Tailoring",
    sweet: "Sweet",
    "semi-sweet": "Semi-Sweet",
    snack: "Snack",
};

const CATEGORY_PATHS = {
    cake: "/cake",
    tailoring: "/tailor",
    sweet: "/sweet",
    "semi-sweet": "/semi-sweet",
    snack: "/snack",
};

const Product = () => {
    const { all_product } = useContext(ShopContext);
    const { productId } = useParams();
    const navigate = useNavigate();
    const product = all_product.find((e) => e.id === Number(productId));
    const { reviews, loading, submitting, addReview, averageRating, reviewCount } = useProductReviews(product?.id);

    if (!product) {
        return (
            <div>
                <ScrollToTop />
            </div>
        );
    }

    const goToTab = (tab) => navigate(`${CATEGORY_PATHS[product.category] || "/"}?tab=${tab}`);
    const activeTab = (product.menu ?? product.subCategory) || "all";

    const categoryLabel = CATEGORY_LABELS[product.category] || "";
    const productDescription = `${product.name} - ${categoryLabel} from Inioli, made fresh in East Brunswick, NJ.`;
    const productJsonLd = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: product.name,
        image: product.image ? [product.image] : undefined,
        description: productDescription,
        offers: {
            "@type": "Offer",
            price: product.new_price,
            priceCurrency: "USD",
            availability: "https://schema.org/InStock",
            url: `${SITE_URL}/product/${product.id}`,
        },
    };

    return (
        <div>
            <Seo title={product.name} description={productDescription} path={`/product/${product.id}`} image={product.image} />
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(productJsonLd)}</script>
            </Helmet>
            <ScrollToTop />
            <CategoryTabs category={product.category} activeTab={activeTab} onSelect={goToTab} />
            {product.category === "cake"
                ? <CakeProductPage key={product.id} product={product} averageRating={averageRating} reviewCount={reviewCount} />
                : <GenericProductPage key={product.id} product={product} averageRating={averageRating} reviewCount={reviewCount} />}
            {/* <DescriptionBox/>
            <RelatedProducts/> */}
            <ProductReviews reviews={reviews} loading={loading} submitting={submitting} onSubmit={addReview} />
        </div>
    )
}

export default Product;